import { TextField } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { AdditionalInfo } from './additional_info'
import { Base } from './base'

export const PhysicalInline = ({ fieldNamePrefix, onKeyPress = () => {} }) => {
  const fieldName = `${fieldNamePrefix}.location`

  return (
    <Base header={I18n.t('publisher.event_type_editor.sections.event_details.location.inlines.physical.header')}>
      <div>
        <TextField
          type="textarea"
          aria-label={I18n.t('publisher.event_types.location.physical_location_label')}
          maxLength={255}
          name={fieldName}
          size="small"
          placeholder={I18n.t('publisher.event_type_editor.sections.event_details.location.inlines.physical.placeholder')}
          onKeyDown={onKeyPress}
        />
        <AdditionalInfo fieldNamePrefix={fieldNamePrefix} />
      </div>
    </Base>
  )
}
